<template>
  <b-navbar class="navbar shadow-sm" sticky>
    <p class="m-0 text-center flex-fill">
      {{ $t('此為預覽畫面') }} - {{ eventStatusLabel }}
    </p>
    <b-button variant="primary" class="btn-go-backstage" @click="goBackstage">
      {{ $t('返回後台頁面') }}
    </b-button>
  </b-navbar>
</template>

<script>
import {stage, manifest} from '@/constant/env.js';
import {EVENT_TYPES} from '@/constant/event.js';
export default {
  data() {
    return {
      stage,
    };
  },
  computed: {
    eventStatus() {
      return this.$store.getters['event/eventStatus'];
    },
    event() {
      return this.$store.getters['event/event'];
    },
    eventStatusLabel() {
      let statusLabel = this.$t('待審核');
      switch (this.tournamentStatus) {
        case 0:
          statusLabel = this.$t('待審核');
          break;
        case 1:
          statusLabel = this.$t('已上架');
          break;
        case 2:
          statusLabel = this.$t('尚未上架');
          break;
        case 3:
          statusLabel = this.$t('已駁回');
          break;
      }
      return statusLabel;
    },
  },
  methods: {
    goBackstage() {
      let _eventStatus = '';
      switch (this.eventStatus) {
        case 0:
          _eventStatus = 'pending';
          break;
        case 1:
          _eventStatus = 'active';
          break;
        case 2:
          _eventStatus = 'active';
          break;
        case 3:
          _eventStatus = 'rejected';
          break;
      }
      let eventName = '';
      if (this.event.type === EVENT_TYPES.ACTIVITY) {
        eventName = 'activity';
      } else if (this.event.type === EVENT_TYPES.TOURNAMENT) {
        eventName = 'tournament';
      } else {
        eventName = 'exam';
      }
      const url = `${manifest.backstage}${eventName}/?state=${_eventStatus}`;
      window.open(url);
    },
  },
};
</script>
<style lang="scss" scoped>
.navbar {
  background: #fff;
  @media screen and (max-width: 575px) {
    background: $primary;
    height: 58px;
  }
  .btn-go-backstage {
    border-radius: 0;
    text-decoration: underline;
  }
}
</style>
